import React from "react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";

import Sidebar from "../Sidebar";

import AuthStore from "stores/AuthStore";

import ROUTES from "navigation/routes";

import BackgroundLight from "components/Layout/Background/BackgroundLight";

import { ContentWrapper, Content, WrappedContainer } from "./styles";

type Props = RouteComponentProps & {
  children?: React.ReactNode;
  header?: React.ReactNode;
  isFullWidth?: boolean;
  isSpread?: boolean;
};

@observer
class Container extends React.Component<Props> {
  onLogout = () => {
    AuthStore?.logout();
    this.props.history.push(ROUTES.LOGIN);
  };

  render() {
    const {
      onLogout,
      props: { match, header, children },
    } = this;

    return (
      <WrappedContainer>
        <Sidebar match={match} user={AuthStore.user} onLogout={onLogout} />
        <ContentWrapper>
          {header}
          <Content>
            <BackgroundLight />
            {children}
          </Content>
        </ContentWrapper>
      </WrappedContainer>
    );
  }
}

export default withRouter(Container);
